export const scrollAnimate = (ref: any) => {
  const onScroll = () => {
    if (typeof window !== 'undefined') {
      const topPos: number = ref.getBoundingClientRect().top;
      const windowHeight = window.innerHeight;

      if (topPos + 400 < windowHeight) {
        ref.classList.remove('wait');
      }
    }
  };

  if (ref) {
    window.addEventListener('scroll', onScroll);
  }

  return () => window.removeEventListener('scroll', onScroll);
};
